import React from 'react';
import styles from 'components/quote_builder_widget/settings/_style.module.scss';

const SECTIONS = [
  { id: 'configuration', label: 'quote_builder_widget.section_configuration', icon: 'fa-cog' },
  { id: 'appearance', label: 'quote_builder_widget.section_appearance', icon: 'fa-paint-brush' },
  { id: 'carton_materials', label: 'quote_builder_widget.section_carton_materials', icon: null },
  { id: 'corrugated_materials', label: 'quote_builder_widget.section_corrugated_materials', icon: null },
];

const SettingsTabs = ({ activeSection, onSectionChange }) => {
  const handleKeyDown = (event, sectionIndex) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onSectionChange(SECTIONS[sectionIndex].id);
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      const nextIndex = (sectionIndex + 1) % SECTIONS.length;
      onSectionChange(SECTIONS[nextIndex].id);
      document.getElementById(`tab-${SECTIONS[nextIndex].id}`)?.focus();
    } else if (event.key === 'ArrowLeft') {
      event.preventDefault();
      const previousIndex = (sectionIndex - 1 + SECTIONS.length) % SECTIONS.length;
      onSectionChange(SECTIONS[previousIndex].id);
      document.getElementById(`tab-${SECTIONS[previousIndex].id}`)?.focus();
    }
  };

  return (
    <div className={styles.tabBar} role="tablist">
      {SECTIONS.map((section, index) => (
        <div
          key={section.id}
          id={`tab-${section.id}`}
          className={activeSection === section.id ? styles.tabItemActive : styles.tabItem}
          onClick={() => onSectionChange(section.id)}
          role="tab"
          tabIndex={activeSection === section.id ? 0 : -1}
          aria-selected={activeSection === section.id}
          aria-controls={`tabpanel-${section.id}`}
          onKeyDown={(event) => handleKeyDown(event, index)}
        >
          {section.icon && <i className={`fa ${section.icon}`} aria-hidden="true"></i>}
          <span>{t(section.label)}</span>
        </div>
      ))}
    </div>
  );
};

export default SettingsTabs;
